import './index.scss';
import * as actionCreators from '../../action-creators';
import ReimbursementSummaryMain from './reimbursement-summary-main';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    selectedLeadAccount: state.reimbursementSummary.summary.leadAccounts.find(leadAccount => leadAccount.leadAccount.account === state.reimbursementSummary.summary.selectedLeadAccount),
    selectedPostingDate: state.reimbursementSummary.summary.selectedPostingDate
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReimbursementSummaryMain);



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/index.js